import React, { useState, useEffect } from 'react';
import Perfiles from "../components/perfiles/libro.js";
import { getmunicipios } from '../services/perfiles/perfiles.js';

const PerfilesPage = () => {
  const [municipios, setMunicipios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [municipioIdvalue, setMunicipioIdvalue] = useState('');
  const [municipioNombre, setMunicipioNombre] = useState('');

  useEffect(() => {
    const fetchMunicipios = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await getmunicipios();
        if (response.status === 200 && response.data) {
          setMunicipios(response.data);
        } else {
          throw new Error('Invalid response from server');
        }
      } catch (error) {
        console.error('Error fetching municipios:', error);
        setError('Error loading data');
      } finally {
        setLoading(false);
      }
    };

    fetchMunicipios();
  }, []);

  const handleChange = (event) => {
    const selectedOption = event.target.options[event.target.selectedIndex];
    setMunicipioIdvalue(selectedOption.value);
    setMunicipioNombre(selectedOption.text);
  };

  return (
    <div style={{ padding: "20px" }}>
      <div>
        {loading && <p>Loading...</p>}
        {error && <p>{error}</p>}
        {!loading && !error && (
          <select onChange={handleChange}>
            <option value="">Seleccione un municipio</option>
            {municipios.map((municipio) => (
              <option key={municipio.oidmunicipio} value={municipio.oidmunicipio}>
                {municipio.municipio}
              </option>
            ))}
          </select>
        )}
      </div>
      <Perfiles municipioId={municipioIdvalue} municipio={municipioNombre} />
    </div>
  );
};

export default PerfilesPage;
